"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
var abstract_1 = __importDefault(require("../abstract"));
var index_1 = __importDefault(require("./index"));
var fetch_1 = require("../../utility/fetch");
var cookie_utility_1 = require("../../utility/cookie_utility");
var CartAddToCart = /** @class */ (function (_super) {
    __extends(CartAddToCart, _super);
    function CartAddToCart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CartAddToCart.prototype.init = function () {
        var _this = this;
        this.setSelector(constants_1.PRODUCTS_SECTION);
        if (this.getElement() === null) {
            return;
        }
        this.productToCartButtons = this.getChildElements("[".concat(constants_1.PRODUCT_GROUP_ID, "]"));
        this.productToCartButtons.forEach(function (element) {
            element.querySelector("[".concat(constants_1.DATA_PRODUCT_BUTTON, "]")).addEventListener('click', function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.addToCart(element)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); });
        });
        this.closeButton = document.querySelector("[".concat(constants_1.DATA_CLOSE, "]"));
        this.closeButton.addEventListener('click', function () {
            _this.closeMessage();
        });
        var modalBackground = document.querySelector("[".concat(constants_1.DATA_MODAL_BACKGROUND, "]"));
        modalBackground.addEventListener('click', function () {
            _this.closeMessage();
        });
    };
    CartAddToCart.prototype.addToCart = function (element) {
        return __awaiter(this, void 0, void 0, function () {
            var productId, quantityObject, quantityValue;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        productId = element.getAttribute(constants_1.PRODUCT_GROUP_ID);
                        quantityObject = element.querySelector("[".concat(constants_1.DATA_PRODUCT_SELECT, "]"));
                        quantityValue = quantityObject.value;
                        return [4 /*yield*/, this.ajaxAddToCart(JSON.stringify({ 'type': 'product', 'productId': productId, 'quantity': quantityValue }))];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.updateCartItemBadge()];
                    case 2:
                        _a.sent();
                        this.openMessage();
                        return [2 /*return*/];
                }
            });
        });
    };
    CartAddToCart.prototype.updateCartItemBadge = function () {
        return __awaiter(this, void 0, void 0, function () {
            var badgeObject, cartEmpty, cartFilled, cartCounter, productCounter, response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        badgeObject = document.querySelector("[".concat(constants_1.DATA_CART_ITEMS, "]"));
                        cartEmpty = document.querySelector("[".concat(constants_1.DATA_CART_EMPTY, "]"));
                        cartFilled = document.querySelector("[".concat(constants_1.DATA_CART_FILLED, "]"));
                        cartCounter = document.querySelector("[".concat(constants_1.DATA_CART_COUNTER, "]"));
                        productCounter = 0;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 10, , 11]);
                        this.ajaxCartUrl = index_1.default.cartObj.getAjaxCart();
                        return [4 /*yield*/, fetch_1.Fetch.fetchGetData(this.ajaxCartUrl)];
                    case 2:
                        response = _a.sent();
                        if (!(response.result.success && response.result.cart)) return [3 /*break*/, 8];
                        productCounter = response.result.cart.number;
                        if (!!cookie_utility_1.CookieUtility.getCookie(constants_1.SW_COOKIE_NAME)) return [3 /*break*/, 6];
                        return [4 /*yield*/, cookie_utility_1.CookieUtility.setCookie('session-', '')];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, cookie_utility_1.CookieUtility.setCookie(constants_1.SW_COOKIE_NAME, response.result.cart.token, 1)];
                    case 4:
                        _a.sent();
                        return [4 /*yield*/, cookie_utility_1.CookieUtility.setCookie(constants_1.SW_COOKIE_CART_COUNT, response.result.cart.number.toString(), 1)];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6: return [4 /*yield*/, cookie_utility_1.CookieUtility.setCookie(constants_1.SW_COOKIE_CART_COUNT, response.result.cart.number.toString(), 1)];
                    case 7:
                        _a.sent();
                        return [3 /*break*/, 9];
                    case 8:
                        productCounter = 0;
                        _a.label = 9;
                    case 9:
                        if (productCounter > 0) {
                            cartEmpty.classList.add('d-none');
                            cartFilled.classList.remove('d-none');
                            cartCounter.classList.remove('d-none');
                        }
                        else {
                            cartEmpty.classList.remove('d-none');
                            cartFilled.classList.add('d-none');
                            cartCounter.classList.add('d-none');
                        }
                        badgeObject.innerHTML = productCounter.toString();
                        return [3 /*break*/, 11];
                    case 10:
                        e_1 = _a.sent();
                        console.log('error: ' + e_1);
                        return [3 /*break*/, 11];
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    CartAddToCart.prototype.openMessage = function () {
        var messageModal = document.querySelector("[".concat(constants_1.DATA_SUCCESS_MESSAGE_MODAL, "]"));
        messageModal.classList.add('show');
        messageModal.classList.remove('modal__init');
        var modalBackground = document.querySelector("[".concat(constants_1.DATA_MODAL_BACKGROUND, "]"));
        modalBackground.classList.remove('hide');
        var domBody = document.querySelector('body');
        domBody.style.overflow = 'hidden';
    };
    CartAddToCart.prototype.closeMessage = function () {
        var messageModal = document.querySelector("[".concat(constants_1.DATA_SUCCESS_MESSAGE_MODAL, "]"));
        messageModal.classList.remove('show');
        var modalBackground = document.querySelector("[".concat(constants_1.DATA_MODAL_BACKGROUND, "]"));
        modalBackground.classList.add('hide');
        var domBody = document.querySelector('body');
        domBody.style.overflow = 'auto';
    };
    CartAddToCart.prototype.ajaxAddToCart = function (products) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        this.ajaxUrl = index_1.default.cartObj.getAjaxAddToCartUrl() + '&tx_wwproject_products[storage]=' + products;
                        return [4 /*yield*/, fetch_1.Fetch.fetchGetData(this.ajaxUrl)];
                    case 1:
                        response = _a.sent();
                        if (!(response.result.success && response.result.cart)) return [3 /*break*/, 3];
                        // get existed cookie
                        return [4 /*yield*/, cookie_utility_1.CookieUtility.setCookie(constants_1.SW_COOKIE_NAME, response.result.cart.token, 1)];
                    case 2:
                        // get existed cookie
                        _a.sent();
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        e_2 = _a.sent();
                        console.log('error:' + e_2);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return CartAddToCart;
}(abstract_1.default));
exports.default = CartAddToCart;
